<template>
  <div v-if="loading" class="row" style="background-color: #fff;">
    <div class="col-12">
      <!-- <div class="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${$t('reports.detractor.loadingLabel')}...`"
        ></b-spinner>
      </div> -->
      <div class="row mt-4">
        <div class="col-3">
          <idx-skeleton height="170" radius="8" />
        </div>
        <div class="col-3">
          <idx-skeleton height="170" radius="8" />
        </div>
        <div class="col-3">
          <idx-skeleton height="170" radius="8" />
        </div>
        <div class="col-3">
          <idx-skeleton height="170" radius="8" />
        </div>
      </div>
      <div class="row m-4 p-2">
        <idx-skeleton width="150" height="150" radius="0" />
        <idx-skeleton width="160" height="150" radius="0" />
        <idx-skeleton width="80" height="150" radius="0" />
      </div>
    </div>
  </div>
  <div v-else class="row" style="max-heigth: 100px">
    <div class="col-12" style="padding: 25px;">
      <div class="reports-wrapper">
        <div class="card">
          <h1 :style="`font-size: ${size}`">{{ $t('reports.sentmentAnalysis.positive') }}</h1>
          <div class="sentiment-area">
            <img :style="`width: ${width}; margin-right: 5px;`" src="../../../../../assets/positive.gif" alt="positive" />
            <span :style="`font-size: ${dataGraph.layout.w <= 6 ? width : '30px'}; font-weight: 500;`">{{
              data.positiveQty
            }}</span>
          </div>
        </div>
        <div class="card">
          <h1 :style="`font-size: ${size}`">{{ $t('reports.sentmentAnalysis.neutral') }}</h1>
          <div class="sentiment-area">
            <img :style="`width: ${width}; margin-right: 5px;`" src="../../../../../assets/neutral.gif" alt="neutral" />
            <span :style="`font-size: ${dataGraph.layout.w <= 6 ? width : '30px'}; font-weight: 500;`">{{
              data.neutralQty
            }}</span>
          </div>
        </div>
        <div class="card">
          <h1 :style="`font-size: ${size}`">{{ $t('reports.sentmentAnalysis.negative') }}</h1>
          <div class="sentiment-area">
            <img :style="`width: ${width}; margin-right: 5px;`" src="../../../../../assets/negative.gif" alt="negative" />
            <span :style="`font-size: ${dataGraph.layout.w <= 6 ? width : '30px'}; font-weight: 500;`">{{
              data.negativeQty
            }}</span>
          </div>
        </div>
        <div class="card">
          <h1 :style="`font-size: ${size}`">{{ $t('reports.sentmentAnalysis.total') }}</h1>
          <div class="sentiment-area" style="flex-direction: column;">
            <span :style="`font-size: ${dataGraph.layout.w <= 6 ? width : '30px'}; font-weight: 500;`">
              {{ data.totalAnswersAnalyzed }}
            </span>
            <p style="font-size: 12px; text-align: center;">
              {{
                `${(
                  (data.totalAnswersAnalyzed / data.totalAnswers) *
                  100
                ).toFixed(2)}% ${$t(
                  'reports.sentmentAnalysis.percentAnalyzed',
                )}`
              }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12" style="width: 100%; display: flex;">
        <div class="col-11">
          <highcharts :options="chartOptions"></highcharts>
        </div>

        <div class="col-1 score">Score {{ score }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import RadialProgressBar from 'vue-radial-progress';
import Indicators from '../../reports/indicators';
import EventBus from '../../../../../eventBus';
import api from '../../../../../services/api';

export default {
  name: 'CardSentiment',

  components: {
    RadialProgressBar,
    Indicators,
    idxSkeleton,
  },

  props: ['dataGraph'],

  data: () => ({
    loading: true,
    data: {
      totalAnswers: 0,
      totalAnswersAnalyzed: 0,
      positiveQty: 0,
      neutralQty: 0,
      negativeQty: 0,
      score: 0,
      scoreColor: '#c1c1c1',
      positiveKeyWords: [],
      neutralKeyWords: [],
      negativeKeyWords: [],
    },
    score: null,
    indicatorSelected: null,
    indicatorLabels: [],
    indicatorsItems: [],
    currentPage: 1,
    loadingIndicators: false,
    chartOptions: {
      chart: {
        type: 'bar',
      },
      title: {
        text: '',
      },
      xAxis: {
        categories: [''],
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
        },
        gridLineWidth: 0,
        visible: false,
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        series: {
          stacking: 'percent',
        },
        bar: {
          dataLabels: {
            style: {
              color: '#fff',
              textOutline: '0px',
              fontWeight: 500,
              fontSize: '16px',
            },
            enabled: true,
            pointFormat: '<span style="">{point.percentage:.0f}%<span/>',
          },
        },
      },
      series: [],
    },
    size: '1rem',
    width: ''
  }),

  methods: {
    async getReportsData() {
      this.loading = true;

      this.indicatorsItems = [];
      this.indicatorSelected = null;

      await this.getSentmentAnalysisInfo(this.dataGraph);

      this.loading = false;
    },

    async getSentmentAnalysisInfo(dataGraph) {
      const response = await api.get('/reports/sentment-analysis-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: dataGraph.actionId ? dataGraph.actionId._id : null,
          startDate: null,
          endDate: null,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: dataGraph.metric,
          groupId: dataGraph.actionGroupId ? dataGraph.actionGroupId._id : null,
          indicator: dataGraph.indicator ? dataGraph.indicator : null,
          indicatorValue: dataGraph.valueIndicator,
          // indicatorRange: this.indicatorData.range,
          period: dataGraph.period,
          _id: dataGraph._id,
        },
      });

      this.score = response.data.score.total;

      this.chartOptions.series = [
        { data: [response.data.qty.positive], color: '#37E688' },
        {
          data: [response.data.qty.neutral],
          color: '#FCBE30',
        },
        { data: [response.data.qty.negative], color: '#E1513D' },
      ];

      this.chartOptions.chart.height = this.dataGraph.layout.h * 25;

      this.data.totalAnswers = response.data.totalAnswers;
      this.data.totalAnswersAnalyzed = response.data.totalAnswersAnalyzed;

      this.data.positiveQty = response.data.qty.positive;
      this.data.neutralQty = response.data.qty.neutral;
      this.data.negativeQty = response.data.qty.negative;
      this.data.score = response.data.score.total;
      this.data.scoreColor = this.setColor(response.data.score.total);

      this.data.positiveKeyWords = response.data.keyWords.positive;
      this.data.neutralKeyWords = response.data.keyWords.neutral;
      this.data.negativeKeyWords = response.data.keyWords.negative;
    },

    setColor(score) {
      if (score >= 60) {
        return '#22CD70';
      } else if (score >= 0) {
        return '#F3C102';
      }

      return '#E84C3E';
    },
  },

  watch: {
    'dataGraph.layout.w': function watchLayoutW(value){
      if(value <= 6){
        this.size = '16px'
        this.width = '24px';
      }else{
        this.size = '21px';
        this.width = '';
      }
    }
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getReportsData();

    if(this.dataGraph.layout.w <= 6){
      this.size = '16px'
      this.width = '24px';
    }else{
      this.size = '21px';
      this.width = '';
    }

    EventBus.$on('update-card-sentiment', (items) => {
      this.getReportsData(items);
    });
  },
};
</script>

<style scoped lang="scss">
.score {
  display: flex;
  align-items: center;
  text-align: center;
  font-weight: 500;
  font-size: 16px;
}

.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reports-wrapper {
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  justify-content: center;
}

.card {
  background-color: #f2f2f2;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-right: 5px;
  padding-left: 5px;
  width: 100%;
  border: 1px solid #f2f2f2;
  margin: 5px;

  h1 {
    font-weight: 400;
    text-align: center;
  }

  .sentiment-area {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.page-spacing {
  padding-left: 15px;
  padding-right: 15px;
}

.graphic-card {
  display: flex;
  flex-direction: column;
  padding: 15px 35px;
  border: 1px solid #f2f2f2;
  height: 100%;
}

.chart-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.text-color {
  color: #5f6368;
  font-size: 18px;
  fill: #5f6368;
}

.highcharts-background-pie {
  width: 0;
}

.numbers-area {
  max-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/sentment-analysis/panels/cards-sentiment.vue